<template>
    <div class="nutrition-vitality">
      <!-- 自定义标题样式，与关键监测结果保持一致 -->
      <div class="key-results-title" v-if="title">
        <h3>{{ title }}</h3>
      </div>
      <div class="horizontal-line"></div>

      <!-- 标签页导航 -->
      <div class="tabs" v-if="false">
        <div 
          v-for="(tab, index) in tabs" 
          :key="index" 
          :class="['tab', { active: activeTabIndex === index }]"
          @click="activeTabIndex = index"
        >
          {{ tab.name }}
        </div>
      </div>

      <!-- 统计信息 -->
      <div class="stats">
        <div class="stat-item warning">
          <div class="stat-label">需要关注</div>
          <div class="stat-value">
            <span class="number">{{ currentTab.warningCount }}</span>/{{ currentTab.warningCount + currentTab.qualifiedCount}}
          </div>
        </div>
        <div class="stat-item qualified">
          <div class="stat-label" style="color: #003BBF;">优良指标</div>
          <div class="stat-value">
            <span class="number">{{ currentTab.qualifiedCount }}</span>/{{ currentTab.warningCount + currentTab.qualifiedCount}}
          </div>
        </div>
      </div>
      
      <!-- 营养素列表 -->
      <div class="nutrition-list">
        <div 
          v-for="(item, index) in currentTab.items" 
          :key="index"
          class="nutrition-item"
           @click="$emit('item-click', item)"
        >
        <div class="item-name-container">
            <div class="item-name">{{ item.name }}</div>
            <div class="item-name-en">{{ item.nameEn || item.item_dict_name_en || '' }}</div>
          </div>
          <div class="item-progress">
            <div class="progress-bar">
              <div 
                class="progress-fill" 
                :style="{ 
                  width: getProgressWidth(item.value),
                  background: getProgressColor(item.value)
                  // background: comeType==='microelement'? 'linear-gradient(to right, #FF5C4D, #B25ED9)':getProgressColor(item.value)
                }"
              ></div>
            </div>
          </div>
          
          <!-- <div class="item-values" v-if="comeType !== 'microelement'">
            <span 
              class="negative-value" 
              :class="{ active: item.value < 0 }"
            >
            {{ isNegative(item.value) ? item.value.toFixed(1) : '-4.0' }}
            </span>
            <span class="divider">|</span>
            <span 
              class="positive-value" 
              :class="{ active: item.value >= 0 }"
            >
            {{ isPositive(item.value) ? '+' + item.value.toFixed(1) : '+4.0' }}
            </span>
          </div> -->
          
          <div class="item-arrow">
            <img src="../assets/进入@2x.png" alt="" class="arrow-icon">
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "NutritionVitalityCard",
    
    props: {
      // 卡片标题
      title: {
        type: String,
        default: "营养活力提示"
      },
      // 标签页数据
      tabsData: {
        type: Array,
        required: true,
        default: () => []
      },
      comeType:{
        type: String,
        default: ""
      }
    },
    
    data() {
      return {
        activeTabIndex: 0
      };
    },
    
    computed: {
      tabs() {
        return this.tabsData;
      },
      
      currentTab() {
        return this.tabs[this.activeTabIndex] || { warningCount: 0, qualifiedCount: 0, items: [] };
      }
    },
    
    methods: {
        getProgressWidth(value) {
  if (value < 0) {
    return `${Math.max(0, Math.min(100, (1 - (value + 4) / 4) * 100))}%`;
    // 负值范围：-4 到 0 映射到 0% 到 100%
    // return `${Math.max(0, Math.min(100, (value + 4) / 4 * 100))}%`;
  } else {
    // 正值范围：0 到 4 映射到 0% 到 100%
    return `${Math.max(0, Math.min(100, value / 4 * 100))}%`;
  }
},
      
      getProgressColor(value) {
        // 负值为红色，正值为蓝色
        return value < 0 ? '#FF5C4D' : '#003CBF';
      },
      isNegative(value) {
        return value < 0;
      },
      
      isPositive(value) {
        return value >= 0;
      }

    }
  };
  </script>
  
  <style lang="scss" scoped>
  .horizontal-line {
    margin-bottom: 40px;
    border-bottom: 1px solid #cccccc;
    width: 100%;
  }
  
  /* 与关键监测结果保持一致的标题样式 */
  .key-results-title {
    padding: 20px 15px 15px;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .key-results-title h3 {
    font-size: 32px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }
  
  .nutrition-vitality {
    .tabs {
      display: flex;
      border-bottom: 1px solid #eee;
      margin-top: 10px;
      margin-bottom: 15px;
      
      .tab {
        flex: 1; 
        padding: 15px 0;
        font-size: 28px;
        text-align: center;
        color: #999;
        position: relative;
        cursor: pointer;
        
        &.active {
          color: #003CBF;
          font-weight: 500;
          
          &:after {
            content: '';
            position: absolute;
            bottom: -1px;
            left: 0;
            width: 100%;
            height: 3px;
            background-color: #003CBF;
          }
        }
      }
    }
    
    .stats {
      display: flex;
      justify-content: center;
      align-self:center;
      margin-bottom: 30px;
      margin-top: 40px;
      
      .stat-item {
        flex: 1;
        
        .stat-label {
          font-size: 22px;
          text-align: center;
          color: #FF5B4D;
          margin-bottom: 5px;
        }
        
        .stat-value {
          font-size: 28px;
          text-align: center;
          
          .number {
            font-size: 40px;
            font-weight: bold;
          }
        }
        
        &.warning .number {
          color: #FF5B4D;
        }
        
        &.qualified .number {
          color: #003BBF;
        }
      }
    }
    
    .nutrition-list {
      .nutrition-item {
        display: flex;
        align-items: center;
        min-height: 66px;
        padding: 15px 0;
        &:last-child {
          border-bottom: none;
        }
        
        .item-name-container {
          width: 140px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .item-name {
          width: 140px;
          font-weight: 400;
          line-height: 1.2;
          font-size: 23px;
          color: #00133D;
          flex-shrink: 0;
          padding-right: 0;
          margin-bottom: 2px;
        }
        
        .item-name-en {
          font-size: 16px;
          color: #959FB7;
          font-weight: 400;
          line-height: 1;
        }
        
        .item-progress {
          flex: 1;
          padding: 0 15px;
          
          .progress-bar {
            height: 6px;
            background-color: #F0F0F0;
            border-radius: 3px;
            overflow: hidden;
            
            .progress-fill {
              height: 100%;
            }
          }
        }
        
        .item-values {
          width: 120px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 20px;
          margin-left: 15px;
          flex-shrink: 0;
          
          .divider {
            color: #959FB7;
            margin: 0 5px;
            font-weight: 400;
            flex: 0 0 auto;
          }
          
          .negative-value, .positive-value {
            color: #959FB7;
            width: 60px;
            text-align: center;
            
            &.active {
              font-weight: bold;
            }
          }
          
          .negative-value {
            text-align: right;
            padding-right: 5px;
            
            &.active {
              color: #FF5B4D;
              font-size: 27px;
            }
          }
          
          .positive-value {
            text-align: left;
            padding-left: 5px;
            
            &.active {
              font-size: 27px;
              color: #003CBF;
            }
          }
        }
        
        .item-arrow {
          width: 40px;
          text-align: center;
          color: #959FB7;
          font-size: 24px;
          flex-shrink: 0;
          
          .arrow-icon {
            width: 38px;
            height: 38px;
            vertical-align: middle;
            margin-left: 13px;
          }
        }
      }
    }
  }
  </style>